import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
  Media: {
    height: '100%',
    width: '100%',
  },

  li: {
    lineHeight: '30px',
  },

  container: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    color: 'black',
  },

  mainWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 'calc(100vh - 50px)',
  },

  leftWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    width: '100%',
  },

  rightWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    width: '100%',
    backgroundColor: theme.palette.primary.dark,
  },

  rightBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'start',
    padding: '10px',
    width: '600px',
    height: '100%',
    color: 'white',
  },

  paperWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '30px',
    width: '100%',
    height: '100%',
  },

  insideH1: {
    marginBottom: 15,
    fontWeight: '300',
    fontSize: '26px',
    lineHeight: '32px',
  },

  insideH4: {
    marginTop: 0,
    marginBottom: 20,
    fontWeight: '300',
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0.15px',
  },

  insideBody: {
    marginBottom: 0,
    fontWeight: 'normal',
    fontSize: '16px',
    lineHeight: '18px',
  },

  signupImage: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    marginTop: '10px',
  },

  logoImage: {
    width: '50%',
    height: '50px',
    marginLeft: 0,
    marginRight: 'auto',
  },

  formBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: '16px',
    width: '480px',
  },

  accountOptions: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },

  formTitle: {
    marginTop: 20,
    marginBottom: 0,
    width: '100%',
    fontWeight: '400',
    fontSize: '32px',
    lineHeight: '40px',
  },

  formSubTitle: {
    marginTop: 5,
    marginBottom: 24,
    width: '100%',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '24px',
  },

  linearProgress: {
    marginTop: '20px',
  },

  alert: {
    width: '100%',
    marginTop: 10,
    marginBottom: '10px',
    padding: '1px 16px 1px 16px',
  },

  footer: {
    marginTop: 'auto',
    backgroundColor: '#E7EAED',
    padding: '10px 10px 15px 10px',
  },

  signupLink: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 15,
    textAlign: 'center',
    textDecoration: 'none !important',
    color: 'black !important',
    fontSize: '15px',
    lineHeight: '26px',
  },

  forgotPasswordLink: {
    paddingTop: 15,
    textAlign: 'center',
  },

  acceptArea: {
    marginTop: '20px',
    marginBottom: '10px',
    color: 'black !important',
  },

  passwordDirections: {
    fontSize: '12px',
    color: '#707974',
  },
}))

export { useStyles }
